// i18n area 'apps' — locale es-MX (task #171, MODELLO DELTA): NON è un
// dizionario intero. Eredita da apps.es-ES.ts e sovrascrive SOLO le chiavi
// che il messicano scrive davvero in un altro modo.
// DA RIVEDERE DA MADRELINGUA: il delta è volutamente STRETTO — il corpus è
// tecnico e le due varianti coincidono quasi ovunque (nessun 'ordenador',
// nessun 'disco duro' divergente, forme di cortesia già in 'usted').
// Sidecar anti-stantie: ../meta/apps.es-MX.meta.json.
import type { DeepPartial } from '../delta'
import type { enUS } from './apps'

export const esMX: DeepPartial<typeof enUS> = {
  ctTemplates: {
    importHint: 'Materializar copia el rootfs al storage elegido — el archivo de catálogo queda intacto. Para añadir nuevos archivos, súbalos antes dentro de un catálogo.',
    sourceFile: 'Archivo de template CT',
    sourceFileHint: 'Los archivos ct-rootfs del catálogo elegido, solo los listos',
    noFiles: 'Ningún archivo ct-rootfs listo en este catálogo — suba uno desde la página del catálogo',
    source: 'Archivo de origen',
    exportHint: 'Empaqueta el rootfs materializado en un NUEVO archivo ct-rootfs en el catálogo elegido — el template queda intacto.',
    exportName: 'Nombre del archivo'
  },
  oci: {
    importCatalogFileHint: 'Los archivos oci-image listos del catálogo elegido.'
  }
}
